import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const unifiedLinksQueryOptions = queryOptions({
  queryFn: () => rpc("getUnifiedLinks", {}),
  queryKey: ["unifiedLinks"],
});
